<template>
  <div class="modal fade" id="mod-add" role="dialog">
    <div
      class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
    >
      <div
        class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] min-h-screen"
      >
        <div class="modal-header- flex items-start justify-between p-0 m-0">
          <h4
            class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
          >
            Invite new customer
          </h4>
          <button
            class="text-2xl text-[#353535] outline-none focus:outline-none"
            type="button"
            data-dismiss="modal"
            aria-hidden="true"
            @click="reset"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div class="m-0 p-0">
          <div class="pb-[16px]">
            <label class="text-[#353535] font-medium text-[14px] leading-[20px]"
              >Send invite via</label
            >
            <div>
              <select
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                :class="[{ 'is-invalid': $v.invitedUser.type.$error }]"
                placeholder="Select an option"
                v-model.trim="$v.invitedUser.type.$model"
              >
                <option value="email">Email</option>
                <option value="sms" v-if="user.type != 'System'">SMS</option>
              </select>
              <div
                class="invalid-feedback"
                v-if="!$v.invitedUser.type.required"
              >
                Field is required.
              </div>
            </div>
          </div>
          <div
            class="pb-[16px]"
            v-if="invitedUser.type == 'sms' || invitedUser.type == 'email'"
          >
            <label class="text-[#353535] font-medium text-[14px] leading-[20px]"
              >Email address</label
            >
            <div>
              <input
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                :class="[{ 'is-invalid': $v.invitedUser.emailAddress.$error }]"
                type="email"
                placeholder="Email address of customer"
                autocomplete="off"
                v-model.trim="$v.invitedUser.emailAddress.$model"
              />
              <div
                class="invalid-feedback"
                v-if="
                  invitedUser.type == 'email' &&
                    !$v.invitedUser.emailAddress.required
                "
              >
                Field is required.
              </div>
              <div
                class="invalid-feedback"
                v-if="!$v.invitedUser.emailAddress.email"
              >
                Email is invalid.
              </div>
            </div>
          </div>
          <div
            class="pb-[16px]"
            v-if="invitedUser.type == 'sms' || invitedUser.type == 'email'"
          >
            <label class="text-[#353535] font-medium text-[14px] leading-[20px]"
              >Phone Number</label
            >
            <div>
              <input
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                :class="[{ 'is-invalid': $v.invitedUser.phoneNumber.$error }]"
                type="tel"
                placeholder="Phone number of customer"
                autocomplete="off"
                v-model.trim="$v.invitedUser.phoneNumber.$model"
                @blur="confirmPhoneNumberUnique"
              />
              <div
                class="text-danger"
                v-if="phoneNumberUnique === false"
                style="font-size:10px"
              >
                The phone number provided has been used.
              </div>
              <div
                class="invalid-feedback"
                v-if="
                  invitedUser.type == 'sms' &&
                    !$v.invitedUser.phoneNumber.required
                "
              >
                Field is required.
              </div>
              <div
                class="invalid-feedback"
                v-if="!$v.invitedUser.phoneNumber.validatePhone"
              >
                Number not valid!
              </div>
            </div>
          </div>
          <div
            class="pb-[16px]"
            v-if="invitedUser.type == 'sms' || invitedUser.type == 'email'"
          >
            <label class="text-[#353535] font-medium text-[14px] leading-[20px]"
              >Name</label
            >
            <div>
              <input
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                :disabled="customerExists"
                :class="[{ 'is-invalid': $v.invitedUser.name.$error }]"
                type="text"
                placeholder="Name of customer"
                v-model.trim="$v.invitedUser.name.$model"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.invitedUser.name.required"
              >
                Field is required.
              </div>
            </div>
          </div>
          <div
            class="pb-[16px]"
            v-if="invitedUser.type == 'sms' || invitedUser.type == 'email'"
          >
            <label class="text-[#353535] font-medium text-[14px] leading-[20px]"
              >Delivery Address</label
            >
            <div>
              <textarea
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                :disabled="customerExists"
                :class="[
                  { 'is-invalid': $v.invitedUser.deliveryAddress.$error },
                ]"
                placeholder="Delivery address of customer"
                v-model.trim="$v.invitedUser.deliveryAddress.$model"
              ></textarea>
              <div
                class="invalid-feedback"
                v-if="!$v.invitedUser.deliveryAddress.required"
              >
                Field is required.
              </div>
            </div>
          </div>
          <div class="pb-[16px]">
            <label class="text-[#353535] font-medium text-[14px] leading-[20px]"
              >Account Manager</label
            >
            <div>
              <select
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                v-model.trim="invitedUser.introducerId"
              >
                <option selected disabled value="null"
                  >Select Account Manager (optional)</option
                >
                <option v-for="c in introducers" :key="c.id" :value="c.id">
                  {{ c.text }}
                </option>
              </select>
            </div>
          </div>
          <div>
            <label class="text-[#353535] font-medium text-[14px] leading-[20px]"
              >Customer Access</label
            >
            <div>
              <select
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                :class="[
                  { 'is-invalid': $v.invitedUser.allowCustomerAccess.$error },
                ]"
                v-model.trim="$v.invitedUser.allowCustomerAccess.$model"
              >
                <option selected disabled>Select an option</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
              <div
                class="invalid-feedback"
                v-if="!$v.invitedUser.allowCustomerAccess.required"
              >
                Field is required.
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center gap-[8px] w-full mt-[24px]">
          <button
            class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
            type="button"
            data-dismiss="modal"
            @click="reset"
          >
            Cancel
          </button>
          <!-- :disabled="isInviting || !phoneNumberUnique" -->
          <button
            class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
            type="button"
            @click.prevent="invite"
          >
            <span
              v-if="isInviting"
              class="spinner-border spinner-border-sm"
              role="status"
            >
              <i class="sr-only">Loading...</i>
            </span>
            <span v-else>Invite</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { helper } from "@/helper";
import { required, email } from "vuelidate/lib/validators";

const validatePhone = (value) => (value ? helper.validatePhone(value) : true);

export default {
  name: "InviteCustomer",

  data() {
    return {
      introducers: [],
      isInviting: false,
      customerExists: false,
      invitedUser: {
        type: "",
        phoneNumber: "",
        emailAddress: "",
        name: "",
        role: "Customer",
        deliveryAddress: "",
        introduerId: "",
        allowCustomerAccess: "",
      },
      phoneNumberUnique: null,
    };
  },

  async created() {
    await this.getIntroducers();
  },

  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },

  validations() {
    const invitedUser = {
      type: { required },
      allowCustomerAccess: { required },
      name: { required },
      deliveryAddress: { required },
    };

    if (this.invitedUser.type === "sms") {
      return {
        invitedUser: {
          ...invitedUser,
          emailAddress: { email },
          phoneNumber: { required, validatePhone },
        },
      };
    } else if (this.invitedUser.type === "email") {
      return {
        invitedUser: {
          ...invitedUser,
          emailAddress: { required, email },
          phoneNumber: { required, validatePhone },
        },
      };
    } else {
      return {
        invitedUser: invitedUser,
      };
    }
  },

  methods: {
    async invite() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isInviting = true;
        try {
          const data = {
            phoneNumber: this.invitedUser.phoneNumber,
            emailAddress: this.invitedUser.emailAddress,
            identifierType: this.invitedUser.type,
            userType: this.user.type,
            name: this.invitedUser.name,
            role: this.invitedUser.role,
            parentId: this.user.parentId,
            deliveryAddress: this.invitedUser.deliveryAddress,
            introducerId: this.invitedUser.introducerId,
            allowCustomerAccess: this.invitedUser.allowCustomerAccess,
            createdBy: this.user.displayName,
          };
          const response = await this.$http.post("/Users/invite", data);
          if (response.ok) {
            this.$toast.success("User invited successfully", {
              icon: true,
              rtl: false,
            });
            this.reset();
            this.$emit("onInviteComplete");
          }
        } catch (error) {}
        this.isInviting = false;
      }
    },
    async getIntroducers() {
      try {
        const response = await this.$http.get(
          "/Users/getItemListOfIntroducers/" + this.user.parentId
        );
        if (response.ok) this.introducers = response.body;
      } catch (error) {
        console.log(error);
      }
    },

    async confirmPhoneNumberUnique() {
      if (this.invitedUser.phoneNumber)
        await this.$http
          .get(
            "/Users/isPhoneNumberUnique/" + `${this.invitedUser.phoneNumber}`
          )
          .then(function(res) {
            this.phoneNumberUnique = res.body;

            if (res.body) {
              this.findUser();
            }
          })
          .catch(function() {});
    },

    async findUser() {
      if (this.invitedUser.phoneNumber.length == 11) {
        try {
          const response = await this.$http.get(
            "/Users/getByPhoneNumber/" + this.invitedUser.phoneNumber
          );
          if (response.ok) {
            this.invitedUser.name = res.body.displayName;
            this.invitedUser.deliveryAddress = res.body.deliveryAddress;
            this.customerExists = true;

            this.$toast.error(
              `This number already exists within our database as ${this.invitedUser.name}. By clicking invite, this customer will be added to your customer list as ${this.invitedUser.name}.`,
              {
                icon: true,
                rtl: false,
              }
            );
          } else {
            this.invitedUser.name = "";
            this.invitedUser.deliveryAddress = "";
            this.customerExists = false;
          }
        } catch (error) {
          this.invitedUser.name = "";
          this.invitedUser.deliveryAddress = "";
          this.customerExists = false;
        }
      }
    },

    reset() {
      this.invitedUser = {
        type: "",
        phoneNumber: "",
        emailAddress: "",
        name: "",
        role: "Customer",
        deliveryAddress: "",
        introduerId: "",
        allowCustomerAccess: "",
      };

      setTimeout(() => {
        this.$v.$reset();
      }, 0);
    },
  },
};
</script>
